export const roleAr = {
  "Role": "الدور",
  "Nom du role": "اسم الدور",
  "Enregistrer": "حفظ",

  // Server Side

  "Le nom existe deja": "الاسم موجود بالفعل",
  "Le nom du role est obligatoire": "اسم الدور مطلوب",
  "Le nom du role doit etre superieur a 3 caracteres": "يجب أن يكون اسم الدور أكبر من 3 أحرف",
  

}